import holidayImages from '@/constants/schedule/ScheduleExceptionImages'
import dayjs from '@/services/date'

const fixedDateHolidayKeys = {
  '12-25': 'christmas',
  '12-26': 'christmas',
  '1-1': 'newYearsDay',
  '12-31': 'newYearsEve',
}

const titleHolidayKeys = {
  easter: ['easter', 'easter holiday'],
  goodFriday: ['good friday'],
  holiday: ['holidays', 'holiday', 'term break', 'half term', 'beach'],
  default2: ['training', 'development', 'pd'],
  athletics: ['athletics', 'sports', 'sports carnival'],
  christmas: ['christmas', 'xmas', 'christmas eve'],
  newYearsDay: ['new years day'],
  newYearsEve: ['new years eve', 'NYE', 'new years', 'new year'],
}

const totalDefaultImages = 5
const usedDefaultImages = new Set()

export default function getExceptionImage(title, date) {
  const key = getKeyByDate(date) || getHolidayKeyByTitle(title)
  let img = holidayImages[key]
  if (!img) img = holidayImages[`default${getNextDefaultNumber()}`]
  return img
}

function getKeyByDate(date) {
  const d = dayjs(date)
  return fixedDateHolidayKeys[`${d.month() + 1}-${d.date()}`] || ''
}

// Rotate through default images 1-5, clearing when all have been used
function getNextDefaultNumber() {
  if (usedDefaultImages.size >= totalDefaultImages) usedDefaultImages.clear()
  const unused = [...Array(totalDefaultImages)]
    .map((_, i) => i + 1)
    .filter((n) => !usedDefaultImages.has(n))
  const selected = unused[Math.floor(Math.random() * unused.length)]
  usedDefaultImages.add(selected)
  return selected
}

function getHolidayKeyByTitle(title) {
  const t = title?.trim().toLowerCase() || ''
  const found = Object.entries(titleHolidayKeys).find(([_, kws]) =>
    kws.some((k) => t.includes(k))
  )?.[0]
  return found || `default${getNextDefaultNumber()}`
}
